"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Svg_1 = require("../Svg");
const Calendar = props => (React.createElement(Svg_1.default, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("g", { stroke: "#fff", strokeWidth: "2", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("rect", { height: "18", rx: "2", width: "18", x: "3", y: "4" }),
        React.createElement("path", { d: "M16 2v4M8 2v4m-5 4h18" }))));
exports.default = Calendar;
